import { ColorConf } from '@/config/color';

export const dialogPaperSx = {
  borderRadius: 4,
  m: 1,
  overflow: 'visible',
  position: 'relative'
};

export const closeButtonSx = {
  position: 'absolute',
  right: 8,
  top: 8,
  color: '#333'
};

export const titleSx = {
  fontWeight: 600,
  color: ColorConf.MonoPrimaryText,
  fontSize: "16px",
  lineHeight: "24px",
};

export const descSx = {
  color: ColorConf.MonoSecondaryText,
  fontSize: "12px",
  lineHeight: "16px",
  mb: 2
};

export const faqLinkSx = {
  display: 'inline-flex',
  alignItems: 'center',
  color: ColorConf.Accent100,
  fontSize: "12px",
  mb: 3,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
    color: ColorConf.Accent100
  }
};

export const skeletonSx = {
  borderRadius: 2
};

export const installButtonSx = {
  backgroundColor: ColorConf.Accent100,
  borderRadius: 10,
  py: 1.5,
  textTransform: 'none',
  fontSize: "14px",
  '&:hover': {
    backgroundColor: ColorConf.Accent100
  }
};

export const desBrowserSx = {
  padding: "2px 8px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  background: ColorConf.MonoBorder,
  borderRadius: "12px",
  width: "fit-content",
};

export const desBrowserTextSx = {
  fontSize: "14px",
  fontWeight: "600",
  color: ColorConf.MonoPrimaryText,
  textTransform: "capitalize"
};

export const stepsGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr 1fr" },
  gap: 0.25,
}

export const boxThumbnailSx = {
  position: "relative",
  height: 55,
  borderRadius: 2,
  overflow: "hidden",
}

export const boxSkeletonSx = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}

export const badgeNumberSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: "8px",
  background: ColorConf.PrimaryForWomen,
  color: ColorConf.White,
  fontWeight: 400,
  fontSize: 14,
}

export const desStepSx = {
  textAlign: "center",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: ColorConf.MonoPrimaryText
}

export const stackStepSx = {
  width: "100%",
  p: 1,
  borderRadius: "16px",
  background: ColorConf.MonoSecondaryBackground,
}
